import _ from 'underscore';

export default function CreativeFromParamFactory($location) {
  const vm = this;
  vm.build = build;

  const CREATIVE_PARAMS = [
    'action',
    'force_click_to_play',
    'instant_play',
    'advertiser',
    'headline',
    'description',
    'media_url',
    'share_url',
    'brand_logo_url',
    'srt_file_url',
    'custom_engagement_url',
    'custom_engagement_label',
    'autoplay_json',
    'headline',
    'thumbnail_url',
    'vast_tag'
  ];

  function build() {
    vm.params = $location.search();

    const creativeParams = _.pick(vm.params, CREATIVE_PARAMS);
    if (_.isEmpty(creativeParams)) {
      return {};
    }

    return {
      action: vm.params.action || 'clickout',
      forceClickToPlay: vm.params.force_click_to_play === 'true',
      instantPlay: vm.params.instant_play === 'true',
      advertiser: vm.params.advertiser || '',
      title: vm.params.headline || '',
      description: vm.params.description || '',
      mediaUrl: vm.params.media_url || '',
      shareUrl: vm.params.share_url || '',
      brandLogoUrl: vm.params.brand_logo_url || '',
      srt: vm.params.srt_file_url || '',
      customEngagementUrl: vm.params.custom_engagement_url || '',
      customEngagementLabel: vm.params.custom_engagement_label || '',
      autoplayJson: vm.params.autoplay_json,
      vastTag: vm.params.vast_tag || vm.params.vastUrl,
      headline: vm.params.headline || '',
      thumbnailUrl: vm.params.thumbnail_url || '',
      beacons: [],
      slides: vm.params.slides ? JSON.parse(vm.params.slides) : [],
      slideshowAutoscroll: vm.params.slideshow_autoscroll === 'true',
      scrollDirection: vm.params.scroll_direction || '',
      isiText: vm.params.isi_text || null,
      isiAutoscroll: vm.params.isi_autoscroll == 'true',
      moatUrl: vm.params.moat_url || ''
    };
  }

  return vm;
}

CreativeFromParamFactory.$inject = ['$location'];
